"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7626],{

/***/ 74129:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(67294);
var React__default = _interopDefault(React);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var blocks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})(BLOCKS = exports.BLOCKS || (exports.BLOCKS = {}));

});

unwrapExports(blocks);
var blocks_1 = blocks.BLOCKS;

var inlines = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */
var INLINES;
(function (INLINES) {
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
})(INLINES = exports.INLINES || (exports.INLINES = {}));

});

unwrapExports(inlines);
var inlines_1 = inlines.INLINES;

var marks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Map of all Contentful marks.
 */
var MARKS;
(function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
})(MARKS || (MARKS = {}));
exports.default = MARKS;

});

unwrapExports(marks);

var schemaConstraints = createCommonjsModule(function (module, exports) {
var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.V1_MARKS = exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;


var marks_1 = __importDefault(marks);
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */
exports.TOP_LEVEL_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    blocks.BLOCKS.TABLE,
];
/**
 * Array of all allowed block types inside list items
 */
exports.LIST_ITEM_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
];
exports.TABLE_BLOCKS = [
    blocks.BLOCKS.TABLE,
    blocks.BLOCKS.TABLE_ROW,
    blocks.BLOCKS.TABLE_CELL,
    blocks.BLOCKS.TABLE_HEADER_CELL,
];
/**
 * Array of all void block types
 */
exports.VOID_BLOCKS = [blocks.BLOCKS.HR, blocks.BLOCKS.EMBEDDED_ENTRY, blocks.BLOCKS.EMBEDDED_ASSET];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */
exports.CONTAINERS = (_a = {},
    _a[blocks.BLOCKS.OL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.UL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS,
    _a[blocks.BLOCKS.QUOTE] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE] = [blocks.BLOCKS.TABLE_ROW],
    _a[blocks.BLOCKS.TABLE_ROW] = [blocks.BLOCKS.TABLE_CELL, blocks.BLOCKS.TABLE_HEADER_CELL],
    _a[blocks.BLOCKS.TABLE_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE_HEADER_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a);
/**
 * Array of all heading levels
 */
exports.HEADINGS = [
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
];
/**
 * Array of all block types that may contain text and inline nodes.
 */
exports.TEXT_CONTAINERS = __spreadArray([blocks.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */
exports.V1_NODE_TYPES = [
    blocks.BLOCKS.DOCUMENT,
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.LIST_ITEM,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    inlines.INLINES.HYPERLINK,
    inlines.INLINES.ENTRY_HYPERLINK,
    inlines.INLINES.ASSET_HYPERLINK,
    inlines.INLINES.EMBEDDED_ENTRY,
    'text',
];
/**
 * Marks before `superscript` & `subscript` release.
 */
exports.V1_MARKS = [marks_1.default.BOLD, marks_1.default.CODE, marks_1.default.ITALIC, marks_1.default.UNDERLINE];

});

unwrapExports(schemaConstraints);
var schemaConstraints_1 = schemaConstraints.V1_MARKS;
var schemaConstraints_2 = schemaConstraints.V1_NODE_TYPES;
var schemaConstraints_3 = schemaConstraints.TEXT_CONTAINERS;
var schemaConstraints_4 = schemaConstraints.HEADINGS;
var schemaConstraints_5 = schemaConstraints.CONTAINERS;
var schemaConstraints_6 = schemaConstraints.VOID_BLOCKS;
var schemaConstraints_7 = schemaConstraints.TABLE_BLOCKS;
var schemaConstraints_8 = schemaConstraints.LIST_ITEM_BLOCKS;
var schemaConstraints_9 = schemaConstraints.TOP_LEVEL_BLOCKS;

var types = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(types);

var nodeTypes = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(nodeTypes);

var emptyDocument = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */
var EMPTY_DOCUMENT = {
    nodeType: blocks.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: blocks.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {},
                },
            ],
        },
    ],
};
exports.default = EMPTY_DOCUMENT;

});

unwrapExports(emptyDocument);

var helpers = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isText = exports.isBlock = exports.isInline = void 0;


/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */
function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (value === obj[key]) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */
function isInline(node) {
    return hasValue(inlines.INLINES, node.nodeType);
}
exports.isInline = isInline;
/**
 * Checks if the node is an instance of Block.
 */
function isBlock(node) {
    return hasValue(blocks.BLOCKS, node.nodeType);
}
exports.isBlock = isBlock;
/**
 * Checks if the node is an instance of Text.
 */
function isText(node) {
    return node.nodeType === 'text';
}
exports.isText = isText;

});

unwrapExports(helpers);
var helpers_1 = helpers.isText;
var helpers_2 = helpers.isBlock;
var helpers_3 = helpers.isInline;

var dist = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;

Object.defineProperty(exports, "BLOCKS", { enumerable: true, get: function () { return blocks.BLOCKS; } });

Object.defineProperty(exports, "INLINES", { enumerable: true, get: function () { return inlines.INLINES; } });

Object.defineProperty(exports, "MARKS", { enumerable: true, get: function () { return __importDefault(marks).default; } });
__exportStar(schemaConstraints, exports);
__exportStar(types, exports);
__exportStar(nodeTypes, exports);

Object.defineProperty(exports, "EMPTY_DOCUMENT", { enumerable: true, get: function () { return __importDefault(emptyDocument).default; } });
var helpers$1 = __importStar(helpers);
exports.helpers = helpers$1;

});

unwrapExports(dist);
var dist_1 = dist.helpers;
var dist_2 = dist.EMPTY_DOCUMENT;
var dist_3 = dist.MARKS;
var dist_4 = dist.INLINES;
var dist_5 = dist.BLOCKS;

function appendKeyToValidElement(element, key) {
    if (React.isValidElement(element) && element.key === null) {
        return React.cloneElement(element, { key: key });
    }
    return element;
}

function nodeListToReactComponents(nodes, options) {
    return nodes.map(function (node, index) {
        return appendKeyToValidElement(nodeToReactComponent(node, options), index);
    });
}
function nodeToReactComponent(node, options) {
    var renderNode = options.renderNode, renderMark = options.renderMark, renderText = options.renderText;
    if (dist_1.isText(node)) {
        return node.marks.reduce(function (value, mark) {
            if (!renderMark[mark.type]) {
                return value;
            }
            return renderMark[mark.type](value);
        }, renderText ? renderText(node.value) : node.value);
    }
    else {
        var children = nodeListToReactComponents(node.content, options);
        if (!node.nodeType || !renderNode[node.nodeType]) {
            return React__default.createElement(React__default.Fragment, null, children);
        }
        return renderNode[node.nodeType](node, children);
    }
}

var _a, _b;
var defaultNodeRenderers = (_a = {},
    _a[dist_5.DOCUMENT] = function (node, children) { return children; },
    _a[dist_5.PARAGRAPH] = function (node, children) { return React__default.createElement("p", null, children); },
    _a[dist_5.HEADING_1] = function (node, children) { return React__default.createElement("h1", null, children); },
    _a[dist_5.HEADING_2] = function (node, children) { return React__default.createElement("h2", null, children); },
    _a[dist_5.HEADING_3] = function (node, children) { return React__default.createElement("h3", null, children); },
    _a[dist_5.HEADING_4] = function (node, children) { return React__default.createElement("h4", null, children); },
    _a[dist_5.HEADING_5] = function (node, children) { return React__default.createElement("h5", null, children); },
    _a[dist_5.HEADING_6] = function (node, children) { return React__default.createElement("h6", null, children); },
    _a[dist_5.EMBEDDED_ENTRY] = function (node, children) { return React__default.createElement("div", null, children); },
    _a[dist_5.UL_LIST] = function (node, children) { return React__default.createElement("ul", null, children); },
    _a[dist_5.OL_LIST] = function (node, children) { return React__default.createElement("ol", null, children); },
    _a[dist_5.LIST_ITEM] = function (node, children) { return React__default.createElement("li", null, children); },
    _a[dist_5.QUOTE] = function (node, children) { return React__default.createElement("blockquote", null, children); },
    _a[dist_5.HR] = function () { return React__default.createElement("hr", null); },
    _a[dist_5.TABLE] = function (node, children) { return (React__default.createElement("table", null,
        React__default.createElement("tbody", null, children))); },
    _a[dist_5.TABLE_ROW] = function (node, children) { return React__default.createElement("tr", null, children); },
    _a[dist_5.TABLE_HEADER_CELL] = function (node, children) { return React__default.createElement("th", null, children); },
    _a[dist_5.TABLE_CELL] = function (node, children) { return React__default.createElement("td", null, children); },
    _a[dist_4.ASSET_HYPERLINK] = function (node) { return defaultInline(dist_4.ASSET_HYPERLINK, node); },
    _a[dist_4.ENTRY_HYPERLINK] = function (node) { return defaultInline(dist_4.ENTRY_HYPERLINK, node); },
    _a[dist_4.EMBEDDED_ENTRY] = function (node) { return defaultInline(dist_4.EMBEDDED_ENTRY, node); },
    _a[dist_4.HYPERLINK] = function (node, children) { return React__default.createElement("a", { href: node.data.uri }, children); },
    _a);
var defaultMarkRenderers = (_b = {},
    _b[dist_3.BOLD] = function (text) { return React__default.createElement("b", null, text); },
    _b[dist_3.ITALIC] = function (text) { return React__default.createElement("i", null, text); },
    _b[dist_3.UNDERLINE] = function (text) { return React__default.createElement("u", null, text); },
    _b[dist_3.CODE] = function (text) { return React__default.createElement("code", null, text); },
    _b[dist_3.SUPERSCRIPT] = function (text) { return React__default.createElement("sup", null, text); },
    _b[dist_3.SUBSCRIPT] = function (text) { return React__default.createElement("sub", null, text); },
    _b);
function defaultInline(type, node) {
    return (React__default.createElement("span", { key: node.data.target.sys.id },
        "type: ",
        node.nodeType,
        " id: ",
        node.data.target.sys.id));
}
/**
 * Serialize a Contentful Rich Text `document` to React tree
 */
function documentToReactComponents(richTextDocument, options) {
    if (options === void 0) { options = {}; }
    if (!richTextDocument) {
        return null;
    }
    return nodeToReactComponent(richTextDocument, {
        renderNode: __assign(__assign({}, defaultNodeRenderers), options.renderNode),
        renderMark: __assign(__assign({}, defaultMarkRenderers), options.renderMark),
        renderText: options.renderText,
    });
}

exports.h = documentToReactComponents;
//# sourceMappingURL=rich-text-react-renderer.es5.js.map


/***/ }),

/***/ 4243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContentfulImage_ContentfulImage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Image/Image.js
var Image = __webpack_require__(38489);
;// CONCATENATED MODULE: ./node_modules/@pcln/contentful-components/lib-esm/utils/trimAssetUrl/trimAssetUrl.js
var protocolRegex = /(^\w+:|^)/g;
var queryRegex = /\?(.*)/g;
function trimAssetUrl(url) {
    return url === null || url === void 0 ? void 0 : url.replace(protocolRegex, '').replace(queryRegex, '');
}
/* harmony default export */ var trimAssetUrl_trimAssetUrl = (trimAssetUrl);
//# sourceMappingURL=trimAssetUrl.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/contentful-components/lib-esm/ContentfulImage/ContentfulImage.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



/** @public */
var ContentfulImage = function (_a) {
    var _b;
    var altText = _a.altText, asset = _a.asset, className = _a.className, desktopFocalPoint = _a.desktopFocalPoint, fit = _a.fit, _c = _a.format, format = _c === void 0 ? 'webp' : _c, height = _a.height, _d = _a.quality, quality = _d === void 0 ? 80 : _d, radius = _a.radius, width = _a.width, rest = __rest(_a, ["altText", "asset", "className", "desktopFocalPoint", "fit", "format", "height", "quality", "radius", "width"]);
    var assetAltText = (asset === null || asset === void 0 ? void 0 : asset.description) || (asset === null || asset === void 0 ? void 0 : asset.title);
    var file = asset === null || asset === void 0 ? void 0 : asset.file;
    var url = trimAssetUrl_trimAssetUrl(file === null || file === void 0 ? void 0 : file.url);
    var dimensions = ((_b = file === null || file === void 0 ? void 0 : file.details) === null || _b === void 0 ? void 0 : _b.image) || {};
    var h = height || dimensions.height;
    var w = width || dimensions.width;
    var heightPixels = h ? "".concat(h, "px") : null;
    var widthPixels = w ? "".concat(w, "px") : null;
    if (!url)
        return null;
    var imageParams = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (fit && { fit: fit })), (desktopFocalPoint && { f: desktopFocalPoint })), (!url.includes('.svg') && { fm: format })), (radius && { r: radius })), (width && { w: width })), (height && { h: height })), { q: quality });
    var imageParamsKeys = Object.keys(imageParams);
    var imageParamString = "?".concat(imageParamsKeys.map(function (key) { return "".concat(key, "=").concat(imageParams[key]); }).join('&'));
    var src = "https:".concat(url).concat(imageParamString);
    return (react.createElement(Image/* default */.Z, __assign({ src: src, alt: altText || assetAltText, height: heightPixels, width: widthPixels, className: className }, rest)));
};
/* harmony default export */ var ContentfulImage_ContentfulImage = ((0,react.memo)(ContentfulImage));
//# sourceMappingURL=ContentfulImage.js.map

/***/ }),

/***/ 77626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContentfulRichText_ContentfulRichText; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Image/Image.js
var Image = __webpack_require__(38489);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Heading/Heading.js
var Heading = __webpack_require__(97331);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Divider/Divider.js
var Divider = __webpack_require__(11477);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js
var index_esm = __webpack_require__(99278);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(37138);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
;// CONCATENATED MODULE: ./node_modules/pcln-design-system/lib-esm/List/List.js
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};




var BaseCSS = (0,styled_components_browser_esm/* css */.iv)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", "px 0;\n  color: ", ";\n\n  & > li {\n    margin: ", "px 0;\n  }\n\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  margin: ", "px 0;\n  color: ", ";\n\n  & > li {\n    margin: ", "px 0;\n  }\n\n  ", ";\n  ", ";\n  ", ";\n"])), (0,dist_index_esm/* default */.Z)('space.1'), (0,utils/* getPaletteColor */.ow)('base'), (0,dist_index_esm/* default */.Z)('space.1'), index_esm/* fontSize */.JB, index_esm/* space */.Dh, index_esm/* width */.bf);
var Ordered = (0,styled_components_browser_esm/* default */.ZP)('ol')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n\n  & > li > * {\n    margin-left: ", "px;\n  }\n"], ["\n  ", ";\n\n  & > li > * {\n    margin-left: ", "px;\n  }\n"])), BaseCSS, (0,dist_index_esm/* default */.Z)('space.2'));
var Unordered = (0,styled_components_browser_esm/* default */.ZP)('ul')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), BaseCSS);
var List = Unordered;
List.ol = Ordered;
List.ol.displayName = 'OrderedList';
List.ul = Unordered;
List.ul.displayName = 'UnorderedList';
/* harmony default export */ var List_List = (List);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=List.js.map
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(2802);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/ContentfulImage/ContentfulImage.js + 1 modules
var ContentfulImage = __webpack_require__(4243);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowUp.js
var ArrowUp = __webpack_require__(25192);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Svg.js
var Svg = __webpack_require__(51557);
;// CONCATENATED MODULE: ./node_modules/pcln-icons/dist/esm/DollarCircle.js
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react.createElement(Svg/* default */.Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1.4 16.1V20h-2.7v-1.9c-1.7-.4-3.2-1.5-3.3-3.4h2c.1 1.1.8 1.9 2.6 1.9 2 0 2.4-1 2.4-1.6 0-.8-.4-1.6-2.7-2.1-2.5-.6-4.2-1.6-4.2-3.7 0-1.7 1.4-2.8 3.1-3.2V4h2.7v1.9c1.9.5 2.8 1.9 2.9 3.4h-2c-.1-1.1-.6-1.9-2.2-1.9-1.5 0-2.4.7-2.4 1.6 0 .8.6 1.4 2.7 1.9 2 .5 4.2 1.4 4.2 3.9 0 2-1.4 3-3.1 3.3z"
  }));
};

var SvgDollarCircle = (0,styled_components_browser_esm/* default */.ZP)(BaseComponent).withConfig({
  displayName: "DollarCircle__SvgDollarCircle",
  componentId: "sc-kfmbka-0"
})(["outline:none;"]);
SvgDollarCircle.isIcon = true;
SvgDollarCircle.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ var DollarCircle = (SvgDollarCircle);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Luggage.js
var Luggage = __webpack_require__(26884);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Pin.js
var Pin = __webpack_require__(28387);
;// CONCATENATED MODULE: ./node_modules/pcln-icons/dist/esm/Seat.js
var Seat_excluded = ["size", "title", "desc", "titleId", "descId"];

function Seat_extends() { Seat_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Seat_extends.apply(this, arguments); }

function Seat_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Seat_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Seat_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Seat_BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = Seat_objectWithoutProperties(_ref, Seat_excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react.createElement(Svg/* default */.Z, Seat_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react.createElement("path", {
    d: "M4 18v3h3v-3h10v3h3v-6H4v3zm15-8h3v3h-3v-3zM2 10h3v3H2v-3zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"
  }));
};

var SvgSeat = (0,styled_components_browser_esm/* default */.ZP)(Seat_BaseComponent).withConfig({
  displayName: "Seat__SvgSeat",
  componentId: "sc-1ukvv0p-0"
})(["outline:none;"]);
SvgSeat.isIcon = true;
SvgSeat.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ var Seat = (SvgSeat);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Smartphone.js
var Smartphone = __webpack_require__(25375);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Success.js
var Success = __webpack_require__(6250);
;// CONCATENATED MODULE: ./node_modules/pcln-icons/dist/esm/Dot.js
var Dot_excluded = ["size", "title", "desc", "titleId", "descId"];

function Dot_extends() { Dot_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Dot_extends.apply(this, arguments); }

function Dot_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Dot_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Dot_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var Dot_BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = Dot_objectWithoutProperties(_ref, Dot_excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react.createElement(Svg/* default */.Z, Dot_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react.createElement("path", {
    d: "M12 7c-2.75 0-5 2.25-5 5s2.25 5 5 5 5-2.25 5-5-2.25-5-5-5z"
  }));
};

var SvgDot = (0,styled_components_browser_esm/* default */.ZP)(Dot_BaseComponent).withConfig({
  displayName: "Dot__SvgDot",
  componentId: "sc-zvvdot-0"
})(["outline:none;"]);
SvgDot.isIcon = true;
SvgDot.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ var Dot = (SvgDot);
;// CONCATENATED MODULE: ./node_modules/@pcln/contentful-components/lib-esm/ContentfulListItem/ContentfulListItem.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




var icons = {
    ArrowUp: ArrowUp/* default */.Z,
    DollarCircle: DollarCircle,
    Luggage: Luggage/* default */.Z,
    Pin: Pin/* default */.Z,
    Seat: Seat,
    Smartphone: Smartphone/* default */.Z,
    Success: Success/* default */.Z,
};
/** @public */
function ContentfulListItem(_a) {
    var iconName = _a.iconName, label = _a.label, props = __rest(_a, ["iconName", "label"]);
    var Icon = icons[iconName] || Dot;
    return (react.createElement(Flex/* default */.Z, __assign({}, props),
        react.createElement(Icon, { size: 14, title: iconName || 'Dot', mr: 2 }),
        react.createElement(ContentfulRichText_ContentfulRichText, { body: label, fontSize: 0, m: 0 })));
}
/* harmony default export */ var ContentfulListItem_ContentfulListItem = ((0,react.memo)(ContentfulListItem));
//# sourceMappingURL=ContentfulListItem.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/contentful-components/lib-esm/ContentfulList/ContentfulList.js
var ContentfulList_assign = (undefined && undefined.__assign) || function () {
    ContentfulList_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ContentfulList_assign.apply(this, arguments);
};
var ContentfulList_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



/** @public */
function ContentfulList(_a) {
    var heading = _a.heading, items = _a.items, props = ContentfulList_rest(_a, ["heading", "items"]);
    return items.length > 0
        ? (react.createElement(Box/* default */.Z, ContentfulList_assign({}, props),
            react.createElement(Text/* default */.ZP, { textStyle: 'heading6', mb: 3 }, heading),
            react.createElement(List_List.ul, { m: 0, p: 0 }, items.map(function (item, index) { return react.createElement(ContentfulListItem_ContentfulListItem, ContentfulList_assign({ key: index }, item, { mb: 2 })); })))) : null;
}
/* harmony default export */ var ContentfulList_ContentfulList = ((0,react.memo)(ContentfulList));
//# sourceMappingURL=ContentfulList.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/contentful-components/lib-esm/ContentfulRichText/ContentfulRichText.js
/* eslint-disable @typescript-eslint/no-unused-vars */
var ContentfulRichText_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var ContentfulRichText_assign = (undefined && undefined.__assign) || function () {
    ContentfulRichText_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ContentfulRichText_assign.apply(this, arguments);
};
var ContentfulRichText_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};







var TableRow = styled_components_browser_esm/* default.tr */.ZP.tr(ContentfulRichText_templateObject_1 || (ContentfulRichText_templateObject_1 = ContentfulRichText_makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var TableCell = styled_components_browser_esm/* default.td */.ZP.td(ContentfulRichText_templateObject_2 || (ContentfulRichText_templateObject_2 = ContentfulRichText_makeTemplateObject(["\n  display: flex;\n  width: 100%;\n"], ["\n  display: flex;\n  width: 100%;\n"])));
var InlineImage = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z)(ContentfulRichText_templateObject_3 || (ContentfulRichText_templateObject_3 = ContentfulRichText_makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var InlineContentfulImage = (0,styled_components_browser_esm/* default */.ZP)(ContentfulImage/* default */.Z)(templateObject_4 || (templateObject_4 = ContentfulRichText_makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var getEmbeddedAsset = function (node, props) {
    var _a, _b;
    var assetProps = node.data.target;
    if ((_b = (_a = assetProps === null || assetProps === void 0 ? void 0 : assetProps.file) === null || _a === void 0 ? void 0 : _a.contentType) === null || _b === void 0 ? void 0 : _b.includes('image')) {
        var url = assetProps.file.url;
        return react.createElement(InlineImage, ContentfulRichText_assign({ src: "https:".concat(url), mx: 1 }, props));
    }
};
var getInlineEmbeddedEntry = function (node, props) {
    var entryProps = node.data.target;
    if ((entryProps === null || entryProps === void 0 ? void 0 : entryProps.contentTypeId) === 'image') {
        return react.createElement(InlineContentfulImage, ContentfulRichText_assign({}, entryProps, { mx: 1 }, props));
    }
    if ((entryProps === null || entryProps === void 0 ? void 0 : entryProps.contentTypeId) === 'list') {
        return react.createElement(ContentfulList_ContentfulList, ContentfulRichText_assign({}, entryProps, props));
    }
};
var Paragraph = function (_a) {
    var children = _a.children, props = ContentfulRichText_rest(_a, ["children"]);
    return react.createElement(Text/* default.p */.ZP.p, ContentfulRichText_assign({}, props), children);
};
var BoldText = function (_a) {
    var children = _a.children, props = ContentfulRichText_rest(_a, ["children"]);
    return (react.createElement(Text/* default.span */.ZP.span, ContentfulRichText_assign({ fontWeight: 'bold' }, props), children));
};
var ItalicText = function (_a) {
    var children = _a.children, props = ContentfulRichText_rest(_a, ["children"]);
    return (react.createElement(Text/* default.span */.ZP.span, ContentfulRichText_assign({ fontStyle: 'italic' }, props), children));
};
var LinkText = function (_a) {
    var children = _a.children, node = _a.node, props = ContentfulRichText_rest(_a, ["children", "node"]);
    var href = node.data.uri;
    return (react.createElement(Link/* default */.Z, ContentfulRichText_assign({ target: '_blank', href: href }, props), children));
};
function getMark(type, text, props) {
    switch (type) {
        case dist.MARKS.BOLD:
            return react.createElement(BoldText, ContentfulRichText_assign({}, props), text);
        case dist.MARKS.ITALIC:
            return react.createElement(ItalicText, ContentfulRichText_assign({}, props), text);
    }
}
function getNode(type, node, children, props) {
    var fontSize = props.fontSize, propsNoFontSize = ContentfulRichText_rest(props, ["fontSize"]);
    var color = props.color, propsNoColor = ContentfulRichText_rest(props, ["color"]);
    switch (type) {
        case dist.BLOCKS.HEADING_1:
            return react.createElement(Heading/* default.h1 */.Z.h1, ContentfulRichText_assign({}, propsNoFontSize), children);
        case dist.BLOCKS.HEADING_2:
            return react.createElement(Heading/* default.h2 */.Z.h2, ContentfulRichText_assign({}, propsNoFontSize), children);
        case dist.BLOCKS.HEADING_3:
            return react.createElement(Heading/* default.h3 */.Z.h3, ContentfulRichText_assign({}, propsNoFontSize), children);
        case dist.BLOCKS.HEADING_4:
            return react.createElement(Heading/* default.h4 */.Z.h4, ContentfulRichText_assign({}, propsNoFontSize), children);
        case dist.BLOCKS.HEADING_5:
            return react.createElement(Heading/* default.h5 */.Z.h5, ContentfulRichText_assign({}, propsNoFontSize), children);
        case dist.BLOCKS.HEADING_6:
            return react.createElement(Heading/* default.h6 */.Z.h6, ContentfulRichText_assign({}, propsNoFontSize), children);
        case dist.BLOCKS.PARAGRAPH:
            return react.createElement(Paragraph, ContentfulRichText_assign({}, props), children);
        case dist.BLOCKS.HR:
            return react.createElement(Divider/* default */.Z, ContentfulRichText_assign({}, props));
        case dist.BLOCKS.UL_LIST:
            return react.createElement(List_List.ul, ContentfulRichText_assign({}, props), children);
        case dist.BLOCKS.OL_LIST:
            return react.createElement(List_List.ol, ContentfulRichText_assign({}, props), children);
        case dist.BLOCKS.TABLE_ROW:
            return react.createElement(TableRow, ContentfulRichText_assign({}, props), children);
        case dist.BLOCKS.TABLE_CELL:
            return react.createElement(TableCell, ContentfulRichText_assign({}, props), children);
        case dist.BLOCKS.EMBEDDED_ASSET:
            return getEmbeddedAsset(node, props);
        case dist.INLINES.EMBEDDED_ENTRY:
            return getInlineEmbeddedEntry(node, props);
        case dist.INLINES.HYPERLINK:
            return (react.createElement(LinkText, ContentfulRichText_assign({}, propsNoColor, { node: node }), children));
    }
}
var options = function (props) {
    var _a, _b;
    return {
        renderText: function (text) { return text.split('\n').flatMap(function (text, i) { return [i > 0 && react.createElement("br", null), text]; }); },
        renderMark: (_a = {},
            _a[dist.MARKS.BOLD] = function (text) { return getMark(dist.MARKS.BOLD, text, props); },
            _a[dist.MARKS.ITALIC] = function (text) { return getMark(dist.MARKS.ITALIC, text, props); },
            _a),
        renderNode: (_b = {},
            _b[dist.BLOCKS.HEADING_1] = function (node, children) { return getNode(dist.BLOCKS.HEADING_1, node, children, props); },
            _b[dist.BLOCKS.HEADING_2] = function (node, children) { return getNode(dist.BLOCKS.HEADING_2, node, children, props); },
            _b[dist.BLOCKS.HEADING_3] = function (node, children) { return getNode(dist.BLOCKS.HEADING_3, node, children, props); },
            _b[dist.BLOCKS.HEADING_4] = function (node, children) { return getNode(dist.BLOCKS.HEADING_4, node, children, props); },
            _b[dist.BLOCKS.HEADING_5] = function (node, children) { return getNode(dist.BLOCKS.HEADING_5, node, children, props); },
            _b[dist.BLOCKS.HEADING_6] = function (node, children) { return getNode(dist.BLOCKS.HEADING_6, node, children, props); },
            _b[dist.BLOCKS.PARAGRAPH] = function (node, children) { return getNode(dist.BLOCKS.PARAGRAPH, node, children, props); },
            _b[dist.BLOCKS.HR] = function () { return getNode(dist.BLOCKS.HR, null, null, props); },
            _b[dist.BLOCKS.UL_LIST] = function (node, children) { return getNode(dist.BLOCKS.UL_LIST, node, children, props); },
            _b[dist.BLOCKS.OL_LIST] = function (node, children) { return getNode(dist.BLOCKS.OL_LIST, node, children, props); },
            _b[dist.BLOCKS.TABLE_ROW] = function (node, children) { return getNode(dist.BLOCKS.TABLE_ROW, node, children, props); },
            _b[dist.BLOCKS.TABLE_CELL] = function (node, children) { return getNode(dist.BLOCKS.TABLE_CELL, node, children, props); },
            _b[dist.BLOCKS.EMBEDDED_ASSET] = function (node, children) { return getNode(dist.BLOCKS.EMBEDDED_ASSET, node, children, props); },
            _b[dist.INLINES.EMBEDDED_ENTRY] = function (node, children) { return getNode(dist.INLINES.EMBEDDED_ENTRY, node, children, props); },
            _b[dist.INLINES.HYPERLINK] = function (node, children) { return getNode(dist.INLINES.HYPERLINK, node, children, props); },
            _b),
    };
};
/** @public */
function ContentfulRichText(_a) {
    var body = _a.body, props = ContentfulRichText_rest(_a, ["body"]);
    return react.createElement(react.Fragment, null, (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(body, options(props)));
}
/* harmony default export */ var ContentfulRichText_ContentfulRichText = (ContentfulRichText);
var ContentfulRichText_templateObject_1, ContentfulRichText_templateObject_2, ContentfulRichText_templateObject_3, templateObject_4;
//# sourceMappingURL=ContentfulRichText.js.map

/***/ }),

/***/ 57931:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/** @public */
function getVariantContent(setiControl, collection) {
    switch (setiControl) {
        case collection.variant1Name:
            return collection.variant1Content;
        case collection.variant2Name:
            return collection.variant2Content;
        case collection.variant3Name:
            return collection.variant3Content;
        case collection.variant4Name:
            return collection.variant4Content;
        case collection.variant5Name:
            return collection.variant5Content;
        default:
            return collection.defaultContent;
    }
}
/* harmony default export */ __webpack_exports__["Z"] = (getVariantContent);
//# sourceMappingURL=getVariantContent.js.map

/***/ }),

/***/ 61388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ContentfulProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26518);


/** @public */
function useContentful(fieldName, defaultValue) {
    var contentful = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ContentfulProvider__WEBPACK_IMPORTED_MODULE_1__/* .ContentfulContext */ .l);
    if (!fieldName) {
        return contentful;
    }
    var pathArray = "fields.".concat(fieldName).split('.');
    return pathArray.reduce(function (prevPath, nextPath) { var _a; return (_a = prevPath === null || prevPath === void 0 ? void 0 : prevPath[nextPath]) !== null && _a !== void 0 ? _a : defaultValue; }, contentful);
}
/* harmony default export */ __webpack_exports__["Z"] = (useContentful);
//# sourceMappingURL=useContentful.js.map

/***/ }),

/***/ 26116:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})(BLOCKS = exports.BLOCKS || (exports.BLOCKS = {}));
//# sourceMappingURL=blocks.js.map

/***/ }),

/***/ 50152:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var blocks_1 = __webpack_require__(26116);
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */
var EMPTY_DOCUMENT = {
    nodeType: blocks_1.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: blocks_1.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {},
                },
            ],
        },
    ],
};
exports["default"] = EMPTY_DOCUMENT;
//# sourceMappingURL=emptyDocument.js.map

/***/ }),

/***/ 42508:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isText = exports.isBlock = exports.isInline = void 0;
var blocks_1 = __webpack_require__(26116);
var inlines_1 = __webpack_require__(65330);
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */
function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (value === obj[key]) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */
function isInline(node) {
    return hasValue(inlines_1.INLINES, node.nodeType);
}
exports.isInline = isInline;
/**
 * Checks if the node is an instance of Block.
 */
function isBlock(node) {
    return hasValue(blocks_1.BLOCKS, node.nodeType);
}
exports.isBlock = isBlock;
/**
 * Checks if the node is an instance of Text.
 */
function isText(node) {
    return node.nodeType === 'text';
}
exports.isText = isText;
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 2802:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;
var blocks_1 = __webpack_require__(26116);
Object.defineProperty(exports, "BLOCKS", ({ enumerable: true, get: function () { return blocks_1.BLOCKS; } }));
var inlines_1 = __webpack_require__(65330);
Object.defineProperty(exports, "INLINES", ({ enumerable: true, get: function () { return inlines_1.INLINES; } }));
var marks_1 = __webpack_require__(65853);
Object.defineProperty(exports, "MARKS", ({ enumerable: true, get: function () { return __importDefault(marks_1).default; } }));
__exportStar(__webpack_require__(35378), exports);
__exportStar(__webpack_require__(72242), exports);
__exportStar(__webpack_require__(20003), exports);
var emptyDocument_1 = __webpack_require__(50152);
Object.defineProperty(exports, "EMPTY_DOCUMENT", ({ enumerable: true, get: function () { return __importDefault(emptyDocument_1).default; } }));
var helpers = __importStar(__webpack_require__(42508));
exports.helpers = helpers;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 65330:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */
var INLINES;
(function (INLINES) {
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
})(INLINES = exports.INLINES || (exports.INLINES = {}));
//# sourceMappingURL=inlines.js.map

/***/ }),

/***/ 65853:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * Map of all Contentful marks.
 */
var MARKS;
(function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
})(MARKS || (MARKS = {}));
exports["default"] = MARKS;
//# sourceMappingURL=marks.js.map

/***/ }),

/***/ 20003:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=nodeTypes.js.map

/***/ }),

/***/ 35378:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.V1_MARKS = exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;
var blocks_1 = __webpack_require__(26116);
var inlines_1 = __webpack_require__(65330);
var marks_1 = __importDefault(__webpack_require__(65853));
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */
exports.TOP_LEVEL_BLOCKS = [
    blocks_1.BLOCKS.PARAGRAPH,
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
    blocks_1.BLOCKS.OL_LIST,
    blocks_1.BLOCKS.UL_LIST,
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.QUOTE,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
    blocks_1.BLOCKS.TABLE,
];
/**
 * Array of all allowed block types inside list items
 */
exports.LIST_ITEM_BLOCKS = [
    blocks_1.BLOCKS.PARAGRAPH,
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
    blocks_1.BLOCKS.OL_LIST,
    blocks_1.BLOCKS.UL_LIST,
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.QUOTE,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
];
exports.TABLE_BLOCKS = [
    blocks_1.BLOCKS.TABLE,
    blocks_1.BLOCKS.TABLE_ROW,
    blocks_1.BLOCKS.TABLE_CELL,
    blocks_1.BLOCKS.TABLE_HEADER_CELL,
];
/**
 * Array of all void block types
 */
exports.VOID_BLOCKS = [blocks_1.BLOCKS.HR, blocks_1.BLOCKS.EMBEDDED_ENTRY, blocks_1.BLOCKS.EMBEDDED_ASSET];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */
exports.CONTAINERS = (_a = {},
    _a[blocks_1.BLOCKS.OL_LIST] = [blocks_1.BLOCKS.LIST_ITEM],
    _a[blocks_1.BLOCKS.UL_LIST] = [blocks_1.BLOCKS.LIST_ITEM],
    _a[blocks_1.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS,
    _a[blocks_1.BLOCKS.QUOTE] = [blocks_1.BLOCKS.PARAGRAPH],
    _a[blocks_1.BLOCKS.TABLE] = [blocks_1.BLOCKS.TABLE_ROW],
    _a[blocks_1.BLOCKS.TABLE_ROW] = [blocks_1.BLOCKS.TABLE_CELL, blocks_1.BLOCKS.TABLE_HEADER_CELL],
    _a[blocks_1.BLOCKS.TABLE_CELL] = [blocks_1.BLOCKS.PARAGRAPH],
    _a[blocks_1.BLOCKS.TABLE_HEADER_CELL] = [blocks_1.BLOCKS.PARAGRAPH],
    _a);
/**
 * Array of all heading levels
 */
exports.HEADINGS = [
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
];
/**
 * Array of all block types that may contain text and inline nodes.
 */
exports.TEXT_CONTAINERS = __spreadArray([blocks_1.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */
exports.V1_NODE_TYPES = [
    blocks_1.BLOCKS.DOCUMENT,
    blocks_1.BLOCKS.PARAGRAPH,
    blocks_1.BLOCKS.HEADING_1,
    blocks_1.BLOCKS.HEADING_2,
    blocks_1.BLOCKS.HEADING_3,
    blocks_1.BLOCKS.HEADING_4,
    blocks_1.BLOCKS.HEADING_5,
    blocks_1.BLOCKS.HEADING_6,
    blocks_1.BLOCKS.OL_LIST,
    blocks_1.BLOCKS.UL_LIST,
    blocks_1.BLOCKS.LIST_ITEM,
    blocks_1.BLOCKS.HR,
    blocks_1.BLOCKS.QUOTE,
    blocks_1.BLOCKS.EMBEDDED_ENTRY,
    blocks_1.BLOCKS.EMBEDDED_ASSET,
    inlines_1.INLINES.HYPERLINK,
    inlines_1.INLINES.ENTRY_HYPERLINK,
    inlines_1.INLINES.ASSET_HYPERLINK,
    inlines_1.INLINES.EMBEDDED_ENTRY,
    'text',
];
/**
 * Marks before `superscript` & `subscript` release.
 */
exports.V1_MARKS = [marks_1.default.BOLD, marks_1.default.CODE, marks_1.default.ITALIC, marks_1.default.UNDERLINE];
//# sourceMappingURL=schemaConstraints.js.map

/***/ }),

/***/ 72242:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 7981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99278);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92591);
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



var Absolute = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  ", " ", " ", " ", "\n  ", "\n"], ["\n  position: absolute;\n  ", " ", " ", " ", "\n  ", "\n"])), styled_system__WEBPACK_IMPORTED_MODULE_2__/* .top */ .we, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .bottom */ .I, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .left */ .t$, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .right */ .F2, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .zIndex */ .W5);
Absolute.propTypes = __assign(__assign(__assign(__assign(__assign({}, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .top.propTypes */ .we.propTypes), styled_system__WEBPACK_IMPORTED_MODULE_2__/* .right.propTypes */ .F2.propTypes), styled_system__WEBPACK_IMPORTED_MODULE_2__/* .bottom.propTypes */ .I.propTypes), styled_system__WEBPACK_IMPORTED_MODULE_2__/* .left.propTypes */ .t$.propTypes), styled_system__WEBPACK_IMPORTED_MODULE_2__/* .zIndex.propTypes */ .W5.propTypes);
Absolute.displayName = 'Absolute';
/* harmony default export */ __webpack_exports__["Z"] = (Absolute);
var templateObject_1;
//# sourceMappingURL=Absolute.js.map

/***/ }),

/***/ 77072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87379);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99278);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98792);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67113);
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var variations = {
    parallax: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-attachment: fixed;\n  "], ["\n    background-attachment: fixed;\n  "]))),
    static: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-attachment: scroll;\n  "], ["\n    background-attachment: scroll;\n  "]))),
};
var image = function (props) { return (props.image ? { backgroundImage: "url(".concat(props.image, ")") } : null); };
var propTypes = __assign(__assign(__assign(__assign({}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .height.propTypes */ .Cb.propTypes), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .width.propTypes */ .bf.propTypes), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .borderRadius.propTypes */ .E0.propTypes), { 
    /** background-image url */
    image: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string), variation: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(Object.keys(variations)), borderRadiusSize: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(_utils__WEBPACK_IMPORTED_MODULE_3__/* .borderRadiusValues */ .Ze), rounded: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(_utils__WEBPACK_IMPORTED_MODULE_3__/* .roundedValues */ .YP) });
var BackgroundImage = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.attrs */ .ZP.div.attrs(_utils__WEBPACK_IMPORTED_MODULE_3__/* .borderRadiusAttrs */ ._U)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  ", "\n  ", " ", " ", " ", ";\n"], ["\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  ", "\n  ", " ", " ", " ", ";\n"])), (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .getPaletteColor */ .ow)('border.light'), (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .applyVariations */ .hO)('BackgroundImage', variations), image, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .borderRadius */ .E0);
BackgroundImage.propTypes = propTypes;
BackgroundImage.defaultProps = {
    variation: 'static',
};
BackgroundImage.displayName = 'BackgroundImage';
/* harmony default export */ __webpack_exports__["Z"] = (BackgroundImage);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=BackgroundImage.js.map

/***/ }),

/***/ 72522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99278);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37138);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98792);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67113);
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





var type = function (props) {
    var badgeColors = {
        blue: {
            backgroundColor: props.theme.colors.blue,
            color: props.theme.colors.white,
        },
        lightBlue: {
            backgroundColor: props.theme.colors.lightBlue,
            color: props.theme.colors.darkBlue,
        },
        green: {
            backgroundColor: props.theme.colors.green,
            color: props.theme.colors.white,
        },
        lightGreen: {
            backgroundColor: props.theme.colors.lightGreen,
            color: props.theme.colors.darkGreen,
        },
        red: {
            backgroundColor: props.theme.colors.red,
            color: props.theme.colors.white,
        },
        lightRed: {
            backgroundColor: props.theme.colors.lightRed,
            color: props.theme.colors.darkRed,
        },
        orange: {
            backgroundColor: props.theme.colors.orange,
            color: props.theme.colors.text,
        },
        gray: {
            backgroundColor: props.theme.colors.gray,
            color: props.theme.colors.white,
        },
        lightGray: {
            backgroundColor: props.theme.colors.lightGray,
            color: props.theme.colors.text,
        },
    };
    return !(props.bg && props.color) && (badgeColors[props.bg] || badgeColors.lightGray);
};
var sizes = {
    small: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    line-height: ", ";\n  "], ["\n    ", "\n    line-height: ", ";\n  "])), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('textStyles.small'), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('lineHeights.display')),
    medium: (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    line-height: ", ";\n  "], ["\n    ", "\n    line-height: ", ";\n  "])), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('textStyles.display0'), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('lineHeights.standard')),
};
var Badge = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.attrs */ .ZP.div.attrs(_utils__WEBPACK_IMPORTED_MODULE_2__/* .borderRadiusAttrs */ ._U)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  text-transform: uppercase;\n  letter-spacing: ", ";\n  ", ";\n  ", ";\n  ", " ", " ", ";\n\n  ", "\n"], ["\n  display: inline-block;\n  text-transform: uppercase;\n  letter-spacing: ", ";\n  ", ";\n  ", ";\n  ", " ", " ", ";\n\n  ", "\n"])), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('letterSpacings.caps'), function (_a) {
    var theme = _a.theme;
    return (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .applySizes */ .BS)(sizes, undefined, theme.mediaQueries);
}, (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .applyVariations */ .hO)('Badge'), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .space */ .Dh, type, _utils__WEBPACK_IMPORTED_MODULE_3__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_4__/* .borderRadius */ .E0);
Badge.displayName = 'Badge';
Badge.propTypes = __assign(__assign({}, styled_system__WEBPACK_IMPORTED_MODULE_4__/* .space.propTypes */ .Dh.propTypes), { size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.keys(sizes)), color: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .deprecatedColorValue */ .nL)(), bg: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .deprecatedPropType */ .aR)('color') });
Badge.defaultProps = {
    size: 'medium',
    px: 2,
    py: 1,
    borderRadius: 'full',
};
/* harmony default export */ __webpack_exports__["Z"] = (Badge);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Badge.js.map

/***/ }),

/***/ 97331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23720);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Heading = function (props) { return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, __assign({ as: 'h3' }, props)); };
Heading.displayName = 'Heading';
Heading.h1 = function (props) { return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Heading, __assign({ as: 'h1', textShadowSize: 'md' }, props)); };
Heading.h2 = function (props) { return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Heading, __assign({ as: 'h2', textShadowSize: 'md' }, props)); };
Heading.h3 = function (props) { return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Heading, __assign({ as: 'h3', textShadowSize: 'sm' }, props)); };
Heading.h4 = function (props) { return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Heading, __assign({ as: 'h4', textShadowSize: 'sm' }, props)); };
Heading.h5 = function (props) { return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Heading, __assign({ as: 'h5', textShadowSize: 'sm' }, props)); };
Heading.h6 = function (props) { return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Heading, __assign({ as: 'h6', textShadowSize: 'sm' }, props)); };
/* harmony default export */ __webpack_exports__["Z"] = (Heading);
//# sourceMappingURL=Heading.js.map

/***/ }),

/***/ 88939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99278);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92591);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92833);
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};





/**
 * Returns an array of values with the same length as numChildren with each item
 * set to the corresponding value in the variation string. If numChildren is greater than
 * the number of digits in variation, the same variation values will be repeated.
 * @param variationWidth - variation string
 * @param numChildren - number of children
 * @returns
 */
var getNonhomogeneousWidths = function (variationWidth, numChildren) {
    var variationWidths = variationWidth.split('-').map(function (width) { return parseInt(width, 10); });
    var widths = [];
    for (var i = 0; i < numChildren; i++) {
        widths.push(variationWidths[i % variationWidths.length] / 100);
    }
    return widths;
};
var getWidthsForVariation = function (variation, numChildren) {
    if (!variation) {
        return null;
    }
    if (variation === '50-50') {
        return Array(numChildren).fill(1 / 2);
    }
    else if (variation === '33-33-33') {
        return Array(numChildren).fill(1 / 3);
    }
    else if (variation === '25-25-25-25') {
        return Array(numChildren).fill(1 / 4);
    }
    else if (variation !== '100') {
        return getNonhomogeneousWidths(variation, numChildren);
    }
    // For when variation is 100
    return Array(numChildren).fill(1);
};
/**
 * Returns an array of responsive arrays of numbers with same length as numChildren. Each value represents the
 * width of the corresponding child.
 * @param variation - variation string to determine how items are sized
 * @param numChildren - number of children
 * @returns
 */
var getChildrenWidths = function (variation, numChildren) {
    if (Array.isArray(variation)) {
        var variationWidths = variation.map(function (v) {
            return getWidthsForVariation(v, numChildren);
        });
        var widthsPerChild = [];
        var _loop_1 = function (i) {
            var widths = variationWidths.map(function (v) { return v && v[i]; });
            widthsPerChild.push(widths);
        };
        for (var i = 0; i < numChildren; i++) {
            _loop_1(i);
        }
        return widthsPerChild;
    }
    else {
        return getWidthsForVariation(variation, numChildren);
    }
};
// Map named sizes to responsive size values from theme
var gapValues = {
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4,
};
/**
 * Returns an object containing responsive arrays of values for mx to apply to
 * the wrapper flex and px values to apply to the children.
 * @param gapProp - value passed in as gap prop
 * @returns
 */
var getGapValues = function (gapProp, rowGapProp) {
    var boxPaddingX;
    var boxPaddingY;
    var flexMarginX;
    var flexMarginY;
    if (Array.isArray(gapProp)) {
        boxPaddingX = gapProp.map(function (gap) { return gapValues[gap]; });
        // These values are negative because we're trying to offset the padding
        // applied to the left of the first item and right of the last item.
        flexMarginX = gapProp.map(function (gap) { return (gapValues[gap] ? -1 * gapValues[gap] : null); });
    }
    else {
        boxPaddingX = gapValues[gapProp];
        flexMarginX = -1 * gapValues[gapProp];
    }
    if (Array.isArray(rowGapProp)) {
        boxPaddingY = rowGapProp.map(function (gap) { return gapValues[gap] || null; });
        flexMarginY = rowGapProp.map(function (gap) { return (gapValues[gap] ? -1 * gapValues[gap] : null); });
    }
    else {
        boxPaddingY = gapValues[rowGapProp];
        flexMarginY = -1 * gapValues[rowGapProp];
    }
    return { boxPaddingX: boxPaddingX, boxPaddingY: boxPaddingY, flexMarginX: flexMarginX, flexMarginY: flexMarginY };
};
var memoGetGapValues = getGapValues;
var ALLOWED_LAYOUT_VALUES = ['50-50', '33-33-33', '33-66', '66-33', '25-25-25-25', '60-40', '40-60', '100'];
var ALLOWED_GAP_VALUES = ['sm', 'md', 'lg', 'xl'];
var propTypes = {
    /** Children will have their widths set based on `variation` */
    children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node.isRequired),
    /** Configure widths of children at different breakpoints. Numbers in each variation
     * represent the width of the element in that position as a percentage of `Layout`'s width.
     */
    variation: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOf(ALLOWED_LAYOUT_VALUES),
        prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOf(ALLOWED_LAYOUT_VALUES)),
    ]).isRequired,
    /** Add space between columns */
    gap: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOf(ALLOWED_GAP_VALUES),
        prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOf(ALLOWED_GAP_VALUES)),
    ]),
    /** Add space between rows */
    rowGap: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOf(ALLOWED_GAP_VALUES),
        prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOf(ALLOWED_GAP_VALUES)),
    ]),
    /** FlexWrap pass down property */
    flexWrap: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    /** Add space between rows */
    stretchHeight: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
};
var ZIndexBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(___WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .zIndex */ .W5);
var Layout = function (_a) {
    var children = _a.children, gap = _a.gap, rowGap = _a.rowGap, variation = _a.variation, stretchHeight = _a.stretchHeight, flexWrap = _a.flexWrap;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getGapValues(gap, rowGap)), gapValues = _b[0], setGapValues = _b[1];
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getChildrenWidths(variation, children.length)), widths = _c[0], setChildrenWidths = _c[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        setGapValues(memoGetGapValues(gap, rowGap));
    }, [gap, rowGap]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        setChildrenWidths(getChildrenWidths(variation, children.length));
    }, [variation, children.length]);
    var boxPaddingX = gapValues.boxPaddingX, boxPaddingY = gapValues.boxPaddingY, flexMarginX = gapValues.flexMarginX, flexMarginY = gapValues.flexMarginY;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(___WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, { flexWrap: flexWrap, mx: flexMarginX, my: flexMarginY, "data-testid": 'layout-flex' }, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (child, idx) {
        return child && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ZIndexBox, { width: widths[idx], px: boxPaddingX, py: boxPaddingY, "data-testid": "box-".concat(idx), zIndex: child.props.zIndex }, react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, {
            minHeight: stretchHeight ? '100%' : undefined,
        })));
    })));
};
Layout.propTypes = propTypes;
Layout.defaultProps = {
    flexWrap: 'wrap',
};
Layout.displayName = 'Layout';
/* harmony default export */ __webpack_exports__["Z"] = (Layout);
var templateObject_1;
//# sourceMappingURL=Layout.js.map

/***/ }),

/***/ 25192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4 12l1.4 1.4L11 7.8V20h2V7.8l5.6 5.6L20 12l-8-8-8 8z"
  }));
};

var SvgArrowUp = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "ArrowUp__SvgArrowUp",
  componentId: "sc-1vtt13m-0"
})(["outline:none;"]);
SvgArrowUp.isIcon = true;
SvgArrowUp.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowUp);

/***/ }),

/***/ 26884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20 6.5h-4v-2c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-11c0-1.1-.9-2-2-2zm-6 0h-4v-2h4v2z"
  }));
};

var SvgLuggage = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "Luggage__SvgLuggage",
  componentId: "sc-ypi30e-0"
})(["outline:none;"]);
SvgLuggage.isIcon = true;
SvgLuggage.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgLuggage);

/***/ }),

/***/ 25375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z",
    fillRule: "evenodd"
  }));
};

var SvgSmartphone = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "Smartphone__SvgSmartphone",
  componentId: "sc-1qqx1qe-0"
})(["outline:none;"]);
SvgSmartphone.isIcon = true;
SvgSmartphone.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgSmartphone);

/***/ }),

/***/ 6250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
var _excluded = ["size", "title", "desc", "titleId", "descId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, _excluded);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm-1.7 14.5L6 12.2 7.2 11l3.1 3.1 6.5-6.5L18 8.8l-7.7 7.7z"
  }));
};

var SvgSuccess = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(BaseComponent).withConfig({
  displayName: "Success__SvgSuccess",
  componentId: "sc-f9iix0-0"
})(["outline:none;"]);
SvgSuccess.isIcon = true;
SvgSuccess.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgSuccess);

/***/ })

}]);